import { render } from "./MaterialView.vue?vue&type=template&id=41543741&scoped=true"
import script from "./MaterialView.vue?vue&type=script&lang=js"
export * from "./MaterialView.vue?vue&type=script&lang=js"

import "./MaterialView.vue?vue&type=style&index=0&id=41543741&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41543741"]])

export default __exports__